(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var btn = document.getElementById('wistyScrollTop');
    var ring = document.getElementById('wistyScrollProgress');
    if (!btn || !ring) return;

    var r = 23;
    var circumference = 2 * Math.PI * r;
    ring.style.strokeDasharray = circumference;
    ring.style.strokeDashoffset = circumference;

    var pageWrapper = document.querySelector('.page-wrapper');

    function getScrollTop() {
      var windowTop = window.scrollY || document.documentElement.scrollTop || 0;
      var wrapperTop = pageWrapper ? pageWrapper.scrollTop : 0;
      return Math.max(windowTop, wrapperTop);
    }

    function getScrollableHeight() {
      var windowMax = document.documentElement.scrollHeight - window.innerHeight;
      var wrapperMax = pageWrapper ? (pageWrapper.scrollHeight - pageWrapper.clientHeight) : 0;
      return Math.max(windowMax, wrapperMax, 1);
    }

    function scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (pageWrapper) pageWrapper.scrollTo({ top: 0, behavior: 'smooth' });
    }

    var lastTop = -1;

    function loop() {
      var scrollTop = getScrollTop();
      if (scrollTop !== lastTop) {
        lastTop = scrollTop;
        var docHeight = getScrollableHeight();
        var progress = Math.min(scrollTop / docHeight, 1);

        ring.style.strokeDashoffset = circumference * (1 - progress);
        btn.classList.toggle('is-visible', scrollTop > window.innerHeight * 0.5);
      }
      requestAnimationFrame(loop);
    }

    requestAnimationFrame(loop);

    btn.addEventListener('click', scrollToTop);
  });
})();